export const http_get = (http_client, path, action_success, action_fail, callback) => {
    http_client.get(path)
        .then(function (response) {
            callback({'type' : action_success, 'data' : response.data});
        })
        .catch(function (error) {
            callback({'type' : action_fail, 'data' : error.response && error.response.data ? error.response.data : null});
        });
}